'use client';

import type { ComponentHrHorizontalLineStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';

import classes from './HrHorizontalLine.module.scss';

const HrHorizontalLine: React.FC<{ blok: ComponentHrHorizontalLineStoryblok }> = ({ blok }) => {
  const hasPlaceholder = Boolean(blok.placeholder?.trim());

  return (
    <div className={classes.wrapper}>
      {hasPlaceholder ? (
        <div aria-orientation="horizontal" className={classes.withLabel} role="separator" {...storyblokEditable(blok)}>
          <span className={classes.line} aria-hidden={true} />
          <span className={classes.text}>{blok.placeholder}</span>
          <span className={classes.line} aria-hidden={true} />
        </div>
      ) : (
        <hr className={classes.hr} {...storyblokEditable(blok)} />
      )}
    </div>
  );
};

export default HrHorizontalLine;
